<mat-card class="tabs-wrapper card-wrapper mat-card-layout">
    <mat-card-content class="row">
        <mx-object-form (customize)="onCustomize($event)" class="multiple-columns">
            <ng-template mxFormField="recaptcha" mxFormFieldPlacement="replace" let-form="form">
                <re-captcha [siteKey]="captchaKey"
                            (resolved)="resolved($event)"
                            formControlName="recaptcha"
                            required>
                </re-captcha>
                <div *ngIf="form.controls['recaptcha'].touched">
                    <mat-error *ngIf="form.controls['recaptcha'].value === null">
                        <prl-label value="label.errors.mandatory"></prl-label>
                    </mat-error>
                </div>
            </ng-template>
        </mx-object-form>
        <div class="block">
            <label class="underline">
                <prl-label value="label.contact.us.my.info"/>
            </label>
            <label class="icon location">
                <prl-label value="label.contact.us.my.address"/>
            </label>
            <a class="icon mail" href="mailto:>{{getLabel('label.contact.us.my.mail')}}">
                <prl-label value="label.contact.us.my.mail"/>
            </a>
            <label class="icon phone">
                <prl-label value="label.contact.us.my.phone"/>
            </label>
        </div>
    </mat-card-content>
    <mx-button [buttonModel]="sendButton"></mx-button>
</mat-card>
